import ZCardContent from '@zenbusiness/zui/CardContent';
import { superstyled } from '@zenbusiness/zui/styles';

export const CardContent = superstyled({
  tag: ZCardContent,
  name: 'BusinessEntityCardContent',
  slot: 'CardContent',
  styles: ({ theme }) => ({
    display: 'flex',
    direction: 'row',
    alignItems: 'center',
    gap: '1rem',
    height: '100%',
    minHeight: '6.5rem',

    [theme.breakpoints.up('md')]: {
      minHeight: '7.5rem',
    },
  }),
});
